module.exports = __webpack_public_path__ + "static/img/img_yewu6.9f4b02c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/img_yewu6.png
// module id = YZip
// module chunks = 1